/**
 * POC stub: page-view / signup analytics no-op.
 */
export function trackPageView(_event: string, _payload?: Record<string, unknown>): void {
  /* no-op */
}
